"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts array to NodeList.
 */
function arrayToNodeList(nodes) {
    // this is how guys from webcomponents do
    // https://github.com/webcomponents/shadydom/blob/master/src/patch-accessors.js#L308
    var nodeList = nodes.slice();
    nodeList.item = function (index) {
        return nodeList[index];
    };
    return nodeList;
}
exports.arrayToNodeList = arrayToNodeList;
